import React from 'react';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import SavedSearchPreview from './SavedSearchPreview';

export default function ViewSearchModal({ isOpen, onClose, search, className }) {
  const { t } = useTranslation();
  if (!search) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('Search Details')}
      className="mx-4"
      wrapperClassName="mx-4"
    >
      <div className="p-4">
        <h3 className="text-lg font-medium mb-4">{search.name}</h3>
        <SavedSearchPreview filters={search.filters} />
      </div>
    </Modal>
  );
}